import React from 'react';
import { Button, Icon } from '@amzn/awsui-components-react';
import { TableHeader } from './components';

export const DistributionsHeader = ({ ...props }) => {
  const noneSelected = props.selectedItems.length === 0;
  const selected = props.selectedItems;
    let stopped = false;
    let inService = false;
    for (let i = 0; i < selected.length; i++) {
        const curr = selected[i];
        if (!stopped) {
            stopped = curr.status === "Stopped";
        }
        if (!inService) {
            inService = curr.status === "InService";
        }
    }
    return (
    <TableHeader
      {...props}
      title="Sandboxes"
      actionButtons={
        <div>
          <Button onClick={props.refresh}><Icon name="refresh" /></Button>
          <Button disabled={noneSelected}>Delete</Button>
          <Button disabled={props.selectedItems.length !== 1} onClick={props.updateSandbox}>Edit</Button>
          <Button disabled={!stopped} onClick={props.startSandbox}>Start</Button>
          <Button disabled={!inService} onClick={props.stopSandbox}>Stop</Button>
          <Button variant="primary" href="/create">Create Sandbox</Button>
        </div>
      }
    />
  );
};
